<script setup>
    import { ref } from 'vue'
    import { NavigationControls } from "../stores/NavigationControls"

    const props = defineProps({
        menu: Object,
        menuScroll: Boolean,
        darkTheme: Boolean
    })
    const navigationControls = NavigationControls()

    let isOpen = ref(false)
</script>
<template>
    <div class="flex gap-8 items-center">
        <a href="/contact-us">
            <button class="hidden sm:inline-block font-bold h-[40px] md:h-[68px] backdrop-blur rounded-full transition duration-300"
                    :class="{
                        'bg-transparent border-transparent hover:text-cintra-orange': menuScroll && !navigationControls.visible,
                        'bg-gradient-to-bl from-white/[0.1] to-transparent dark:text-white border-b border-b-gray-800 border-t border-t-gray-500 hover:border-t-gray-800 hover:border-b-cintra-orange hover:text-cintra-orange hover:shadow-md hover:shadow-cintra-orange/25': !menuScroll || navigationControls.visible
                    }">
                <span class="inline-flex items-center gap-4 h-full py-1.5 px-4 md:py-3 md:px-6"><i class="fa-light fa-comments text-base md:text-lg lg:text-xl xl:text-2xl"></i>Talk to an expert</span>
            </button>
        </a>
        <div
            class="gradient-button gradient-button--nav-toggle"
            :class="{
                'bg-transparent' : navigationControls.visible,
                'gradient-button--nav-toggle--active' : navigationControls.visible
            }"
        >
            <button
                type="button"
                aria-label="Toggle the navigation menu"
                class="navigation-button items-center relative appearance-none transition duration-300 border-y border-transparent h-[60px]"
                :class="{
                    'bg-transparent hover:border-t-gray-900 hover:border-b-cintra-orange hover:shadow-md hover:shadow-cintra-orange/25 focus:shadow-lg focus:border-b focus:border-b-cintra-orange focus:border-t focus:border-t-gray-900 focus:shadow-cintra-orange/25' : navigationControls.visible,
                    'bg-cintra-grey' : !navigationControls.visible
                }"
                @click.prevent="navigationControls.toggle()"
            >
                <div
                    aria-hidden='true'
                    class="navigation-button__hamburger tham tham-e-spin tham-w-8 h-7"
                    :class="{
                        'tham-active' : navigationControls.visible
                    }"
                >
                    <div class="tham-box">
                        <div
                            class="navigation-button__hamburger-inner tham-inner"
                            :class="{
                                'bg-cintra-orange' : navigationControls.visible,
                                'bg-white' : !navigationControls.visible && darkTheme && !menuScroll,
                                'bg-cintra-grey md:bg-white' : !navigationControls.visible && menuScroll || !navigationControls.visible && !darkTheme
                            }"
                        />
                    </div>
                </div>
                <div class="navigation-button__text transition duration-500 hidden md:block">
                    <transition name="toggle-text">
                        <span v-show="!navigationControls.visible"
                              class="font-bold inline-block transition duration-500 max-w-[64px] pl-[14px]">
                            Menu
                        </span>
                    </transition>
                </div>
            </button>
        </div>
    </div>
</template>

<style>
    .toggle-text-enter-active,
    .toggle-text-leave-active {
        transition: all 0.5s ease;
    }
    .toggle-text-enter-from,
    .toggle-text-enter,
    .toggle-text-leave-to /* .toggle-text-leave-active in <2.1.8 */ {
        opacity: 0;
        max-width: 0px;
        padding-left: 0px;
    }
    .toggle-text-enter-to {
        opacity: 1;
        max-width: 64px;
        padding-left: 14px;
    }
</style>
